/**
 * Global RTB batch-create progress banner.
 *
 * Mounted once into document.body at app startup (via app.js), same pattern as
 * companyContextModal.js. It has to live outside any single AngularJS route: a bulk-create run
 * (tracked in useBulkInvoiceCreateStore) survives navigating away from Ready to Bill, so the
 * progress indicator needs to as well.
 */
import { createVueIsland } from '@/createVueIsland';
import BulkInvoiceCreateBanner from '@/components/BulkInvoiceCreateBanner.vue';

const host = document.createElement('div');
document.body.appendChild(host);

createVueIsland(BulkInvoiceCreateBanner).mount(host);
